import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth as authApi } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('pbb_token');
    if (!token) { setLoading(false); return; }
    authApi.me().then(u => setUser(u)).catch(() => {
      localStorage.removeItem('pbb_token');
      localStorage.removeItem('pbb_user');
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { token, user } = await authApi.login(email, password);
    localStorage.setItem('pbb_token', token);
    localStorage.setItem('pbb_user', JSON.stringify(user));
    setUser(user);
    return user;
  };

  const signup = async (data) => {
    const { token, user } = await authApi.signup(data);
    localStorage.setItem('pbb_token', token);
    localStorage.setItem('pbb_user', JSON.stringify(user));
    setUser(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem('pbb_token');
    localStorage.removeItem('pbb_user');
    setUser(null);
  };

  const setUserData = (u) => {
    localStorage.setItem('pbb_user', JSON.stringify(u));
    setUser(u);
  };

  const refresh = async () => {
    try {
      const u = await authApi.me();
      setUserData(u);
      return u;
    } catch (e) { return null; }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, logout, setUserData, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
